/* Signature — faceted filtering with Section Rendering partial reloads.
   The form works without JS; this layer avoids full page reloads,
   syncs the URL, and mirrors facets into the mobile drawer. */
(function () {
  'use strict';

  const root = document.getElementById('collection-root');
  if (!root) return;
  const sectionId = root.getAttribute('data-section-id');

  function currentForm() {
    return document.querySelector('[data-facet-form]');
  }

  function buildUrl() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams();

    const sort = document.querySelector('[data-sort-select]');
    if (sort && sort.value) params.set('sort_by', sort.value);

    const form = currentForm();
    if (form) {
      const data = new FormData(form);
      for (const [key, value] of data.entries()) {
        if (value !== '') params.append(key, value);
      }
    }
    url.search = params.toString();
    return url;
  }

  async function refresh() {
    const url = buildUrl();
    const grid = document.querySelector('[data-product-grid]');
    if (grid) grid.setAttribute('aria-busy', 'true');
    try {
      const fresh = await window.sigFetchSection(sectionId, url.toString());
      const freshRoot = fresh.querySelector('#collection-root') || fresh;
      const target = document.getElementById('collection-root');
      if (target && freshRoot) {
        target.replaceWith(freshRoot);
        window.history.pushState({}, '', url.toString());
        bind();
        if (window.sigAnnounce) {
          const count = document.querySelector('[data-product-count]');
          window.sigAnnounce(count ? count.textContent.trim() : 'Results updated');
        }
      }
    } catch (e) {
      window.location.assign(url.toString()); /* graceful fallback */
    }
  }

  const debouncedRefresh = () => {
    clearTimeout(debouncedRefresh.t);
    debouncedRefresh.t = setTimeout(refresh, 350);
  };

  function bind() {
    const form = currentForm();
    if (form) {
      form.addEventListener('change', debouncedRefresh);
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        refresh();
      });
    }
    const sort = document.querySelector('[data-sort-select]');
    if (sort) sort.addEventListener('change', refresh);

    /* Mirror facets into the mobile drawer when opened. */
    const drawerBody = document.querySelector('[data-facet-drawer-body]');
    const drawer = document.getElementById('facet-drawer');
    if (drawer && drawerBody && form) {
      drawer.addEventListener('close', () => {
        drawerBody.textContent = '';
      });
      document.querySelectorAll('[data-dialog-open="#facet-drawer"]').forEach((btn) => {
        btn.addEventListener('click', () => {
          drawerBody.textContent = '';
          const clone = form.cloneNode(true);
          clone.id = 'facet-form-drawer';
          clone.addEventListener('change', () => {
            /* copy state back to the primary form, then refresh */
            const primary = currentForm();
            if (!primary) return;
            const inputs = clone.querySelectorAll('input');
            inputs.forEach((inp, i) => {
              const main = primary.querySelectorAll('input')[i];
              if (!main) return;
              if (inp.type === 'checkbox') main.checked = inp.checked;
              else main.value = inp.value;
            });
            debouncedRefresh();
          });
          drawerBody.appendChild(clone);
        });
      });
    }
  }

  window.addEventListener('popstate', () => window.location.reload());
  bind();
})();
